import { noop, type QueryClient } from "@tanstack/react-query";

import { query } from "@/queries";

/**
 * The route waits on the account file. Visits, catalogs, crops, hybrids and
 * John Deere status start in parallel and can arrive after the name. Live
 * machines stay gated on an active connection inside the page.
 *
 * A preload (hovering a link to the client) reads only the file and its
 * visits, the first tab: a pointer crossing the list should not cost a
 * request per catalog. The rest starts when the client is actually opened.
 */
export function loadCustomerDetail(
  queryClient: QueryClient,
  customerId: string,
  preload = false
) {
  void queryClient.query(query.visits.forAccount(customerId)).catch(noop);
  if (!preload) {
    void queryClient.query(query.catalogs.technologies()).catch(noop);
    void queryClient.query(query.catalogs.advancedTechnologies()).catch(noop);
    void queryClient.query(query.catalogs.fleetTechnologies()).catch(noop);
    void queryClient.query(query.catalogs.crops()).catch(noop);
    void queryClient.query(query.catalogs.varieties(null)).catch(noop);
    void queryClient
      .query(query.johnDeere.accountStatus(customerId))
      .catch(noop);
  }
  return queryClient.query(query.customers.accountDetail(customerId));
}
